import type { TFunction } from 'i18next';
import type { BlockDataRequestDto } from '@reports/application/dtos';
import type { ExportConfig } from '@reports/domain/value-objects';
import { formatDate } from './reportDates';

/**
 * Generates filename from export config and date range
 *
 * Format: "report_name DD-MM-YYYY - DD-MM-YYYY.xlsx"
 *
 * @param exportConfig - Export configuration with name
 * @param request - Request with date range
 * @param t - Translation function from i18next
 * @returns {string} Generated filename
 *
 * @example
 * const filename = generateFilename(exportConfig, request, t);
 * // Returns: "Sales Report 15-01-2025 - 20-01-2025.xlsx"
 */
export const generateFilename = (exportConfig: ExportConfig, request: BlockDataRequestDto, t: TFunction): string => {
  const reportName = t(exportConfig.name);
  const startDateFormatted = formatDate(request.startDate);
  const endDateFormatted = formatDate(request.endDate);
  const fileExtension = '.xlsx';

  return `${reportName} ${startDateFormatted} - ${endDateFormatted}${fileExtension}`;
};
